import { useState, useEffect } from "react";
import PageLayout from "../../../layouts/PageLayout";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import ACTGroupTableComponent from "../../../components/tables/ACTGroupTableComponent";

export default function AllActGroups() {

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const AuthToken = localStorage.getItem("AuthUser");

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;


  useEffect(() => {
    fetchGroups();
  }, []);


  const fetchGroups = async () => {

    try {

      setLoading(true);

      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/act-groups"
      );

      /*
       * Supports:
       *
       * data.data.data -> Laravel pagination
       * data.data      -> normal response
       * data.groups    -> if backend uses groups key
       */

      let groupData = [];

      if (Array.isArray(response.data?.data?.data)) {

        groupData = response.data.data.data;

      } else if (Array.isArray(response.data?.data)) {

        groupData = response.data.data;

      } else if (Array.isArray(response.data?.groups)) {

        groupData = response.data.groups;

      }

      setGroups(groupData);

    } catch (error) {

      console.error(
        "Error While Fetching ACT Groups",
        error
      );

    } finally {

      setLoading(false);

    }
  };


  /*
   * Map API data for table
   */
  const mappedData = groups.map((group) => ({

    id: group.id,
    group_code: group.group_code || "-",
    group_name:
      group.group_name || "-",

    city:
      group.city?.name ||
     
      "-",

    address:
      group.address || "-",

    gender:
      group.group_gender === 1 ||
      group.group_gender === "1"
        ? "Male"
        : group.group_gender === 2 ||
          group.group_gender === "2"
        ? "Female"
        : group.group_gender || "-",

    date:
      group.date || "-",

    agreed_amount:
      group.agreed_amount || 0,

    saving_frequency:
      group.saving_frequency || "-",

    meeting_frequency:
      group.meeting_frequency || "-",

    mobilizers:
      group.mobilizers || "-",

    members_count:
      group.members_count ??
      group.members?.length ??
      0,

    meetings_count:
      group.meetings_count ??
      group.meetings?.length ??
      0,

    action: {
      view: "visibility",
      edit: "edit",
    },

  }));


  return (

    <PageLayout style={{ height: "100%" }}>

      {/* Breadcrumb */}

      <Row>

        <Col xl={12}>

          <div className="mc-card">

            <div className="mc-breadcrumb">

              <h3 className="mc-breadcrumb-title">

                <i className="material-icons">
                  groups
                </i>

                All ACT Groups

              </h3>


              <ul className="mc-breadcrumb-list">

                <li className="mc-breadcrumb-item">

                  <Link
                    to="/"
                    className="mc-breadcrumb-link"
                    style={{
                      color: "#077834"
                    }}
                  >
                    Home
                  </Link>

                </li>


                <li className="mc-breadcrumb-item">
                  ACT Groups
                </li>


                <li className="mc-breadcrumb-item">
                  List
                </li>

              </ul>

            </div>

          </div>

        </Col>

      </Row>


      {/* Table */}

      <Row>

        <Col xl={12}>

          <div className="mc-card">

            <div
              className="d-flex justify-content-between align-items-center mb-3"
            >

              <h4 className="mb-0">
                ACT Groups ({groups.length})
              </h4>


           

            </div>


            {loading ? (

              <div className="text-center py-5">

                <div
                  className="spinner-border text-success"
                  role="status"
                >
                  <span className="visually-hidden">
                    Loading...
                  </span>
                </div>

                <div className="mt-2">
                  Loading ACT Groups...
                </div>

              </div>

            ) : (

              <ACTGroupTableComponent

                thead={[
                  "Group ID",
                  "Group Name",
                  "City",
                
                  "Gender",
                  "Date",
                  "Agreed Amount",
                 
                  "Members",
                  "Meetings",
                  "Action",
                ]}

                tbody={mappedData}

              />

            )}

          </div>

        </Col>

      </Row>

    </PageLayout>

  );
}